/**
 * Partially obscure an email for display in places where the full address
 * isn't necessary — keep enough of the local part for the user to recognise
 * their own address, but not so much that it becomes a casual onlooker
 * disclosure. Domain stays visible so typos are still catchable.
 *
 * "brian@gmail.com" -> "br****@gmail.com"
 */
export function maskEmail(email: string | undefined | null): string {
  if (!email) return '';

  const atIndex = email.indexOf('@');
  if (atIndex < 1) return email;

  const local = email.slice(0, atIndex);
  const domain = email.slice(atIndex);
  const visible = local.slice(0, Math.min(2, local.length));
  const maskedCount = Math.max(local.length - visible.length, 4);
  return `${visible}${'*'.repeat(maskedCount)}${domain}`;
}
